import React from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { Formik, Form } from "formik";

import { FormHelper, ValidationHelper } from "../../helpers";
import { FieldGroup } from "../../components/index.jsx";
import { AddressFieldset } from "../../forms/index.jsx";
import { FormFooter, TermsCheckbox } from "./index.jsx";
const RECAPTCHA_SITE_KEY = import.meta.env.VITE_RECAPTCHA_SITE_KEY;

const Step2 = ({
  goBack,
  values,
  onFinalStepCompleted,
  isMerchantClient,
  recaptchaRef,
}) => {
  const fields = ["address"];

  if (!isMerchantClient) {
    fields.push("accept_terms");
  }

  const validationSchema = ValidationHelper.schema(fields);
  const initialValues = FormHelper.initialValues(fields, values);
  return (
    <>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onFinalStepCompleted}
      >
        {({ isSubmitting, ...props }) => (
          <Form>
            <div className="row">
              <div className="col-md-6 pr-16">
                <FieldGroup placeholder="Job Title" name="title" />
              </div>
              <div className="col-md-6 pr-16">
                <FieldGroup
                  placeholder="Company"
                  type="company"
                  name="company"
                />
              </div>
            </div>

            <FieldGroup
              placeholder="Nationality"
              type="nationality"
              name="nationality_id"
            />

            <AddressFieldset nameObject="address" {...props} />

            <ReCAPTCHA
              ref={recaptchaRef}
              size="invisible"
              sitekey={RECAPTCHA_SITE_KEY}
            />

            {!isMerchantClient && <TermsCheckbox />}

            <FormFooter
              step={2}
              isSubmitting={isSubmitting}
              goBack={goBack}
              isMerchantClient={isMerchantClient}
            />
          </Form>
        )}
      </Formik>
    </>
  );
};

export default Step2;
